/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($, RP6, RP6_VARS) {

  //
  //
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  //
  //

  var SK = {

    // All pages
    'common': {
      init: function(){
        //console.log('SK.common.init');
        NodeList.prototype.forEach = Array.prototype.forEach;
        RP6.general.init();
        RP6.general.bootstrapDropdownHover();
        RP6.general.backToTop();
        RP6.general.expandButton();
        RP6.general.featureBarCount();
        RP6.general.adaptiveNavigation();
        RP6.general.checkCarouselIndicators();
        RP6.search.init();
        RP6.general.noSearchResults();
        RP6.general.floatLabels();
        RP6.general.slideshow();

        //Function later / Overbodige code??:
        //Form
        //575
        if (window.matchMedia('(max-width: 575px)').matches) {
            var group = $(".has-search--bar fieldset.form-group").not(".search--top__expand fieldset");
            for(var i = 0; i < group.length; i++) {
                var item = group[i];
                $('.search--top__expand').prepend(item);
            }
        }

      },
      finalize: function(){
        //console.log('SK.common.finalize');

      }
    },

    // Run on page with body class `home` (if class contains dashes, change them to underscores. ie. use `page_contact` if class is `page-contact`)

    'home': {
      init: function(){
        //console.log('SK.home.init');
        RP6.home.init();
        RP6.general.sidebarFixed("home");
      },
      finalize: function(){
        //console.log('SK.home.finalize');

      }
    },


    'publication_detail': {
      init: function(){
        RP6.detail.init();
        RP6.detail.formSubmitted("#frm_contact");
        RP6.detail.contactMagnificPopup(".btn--contact");
        RP6.detail.contactMagnificPopup(".mailafriend--modal"); 
        RP6.detail.contactMagnificPopup(".btn--visit"); 
        RP6.detail.fuseLegalTable();
        RP6.detail.splitTableChar();
        RP6.general.initProjectLabels();
        RP6.general.submitForm("form");

        $('.nav-tabs .nav-link').on('click', function(e) {
            e.preventDefault();
            $(this).tab('show');
            var theThis = $(this);
            $('.nav-tabs .nav-link').removeClass('active');
            theThis.addClass('active');
        });

        //Detail jumbotron
        RP6.detail.mediaMagnificPopup('.wrap--jumbotron__detail', {
            items: [
                {
                    src: $(".wrap--jumbotron__detail").data("image"),
                    title: $(".wrap--jumbotron__detail").data("alt")
                },
            ],
            type: 'image'
        });
      },
      finalize: function(){}
      },

      'holidayrent_detail': {
          init: function () {
              RP6.detail.init();
              //RP6.holidayrent.initDetail();
              RP6.detail.formSubmitted("#frm_contact");
              RP6.detail.contactMagnificPopup(".btn--contact");
              RP6.detail.contactMagnificPopup(".mailafriend--modal");
              RP6.detail.contactMagnificPopup(".btn--visit");
              RP6.detail.fuseLegalTable();
              RP6.detail.splitTableChar();
              RP6.general.initProjectLabels();
              RP6.general.submitForm("form");

              $('.nav-tabs .nav-link').on('click', function (e) {
                  e.preventDefault();
                  $(this).tab('show');
                  var theThis = $(this);
                  $('.nav-tabs .nav-link').removeClass('active');
                  theThis.addClass('active');
              });

              //Detail jumbotron
              RP6.detail.mediaMagnificPopup('.wrap--jumbotron__detail', {
                  items: [
                      {
                          src: $(".wrap--jumbotron__detail").data("image"),
                          title: $(".wrap--jumbotron__detail").data("alt")
                      },
                  ],
                  type: 'image'
              });
          },
          finalize: function () { }
      },

    'publication_search': {
      init: function(){
        RP6.offer.init();
        RP6.offer.changeView({ containerClass: "card-deck" });
        RP6.general.imageButtonHoverState();
        RP6.general.floatLabels();
        RP6.general.initProjectLabels();

        if(RP6_VARS.search === 'search_fixed'){
          RP6.general.sidebarFixed();
        }
        if(RP6_VARS.scroll === 'infinite'){
          RP6.general.infiniteScroll();
        }
        if(RP6_VARS.scroll === 'infinite_button'){
            RP6.general.infiniteScroll(true);
        }
      },
      finalize: function(){}
      },

      'holidayrent_search': {
          init: function () {
              RP6.offer.init();
              RP6.offer.changeView({ containerClass: "card-deck" });
              RP6.general.imageButtonHoverState();
              RP6.general.floatLabels();
              RP6.general.initProjectLabels();

              if (RP6_VARS.search === 'search_fixed') {
                  RP6.general.sidebarFixed();
              }
              if (RP6_VARS.scroll === 'infinite') {
                  RP6.general.infiniteScroll();
              }
              if (RP6_VARS.scroll === 'infinite_button') {
                  RP6.general.infiniteScroll(true);
              }
          },
          finalize: function () { }
      },

    'contact': {
      init: function(){
        RP6.general.floatLabels();
        RP6.general.submitForm("form");
      },
      finalize: function(){}
    },

    'mail_a_friend': {
      init: function(){
        RP6.general.floatLabels();
        RP6.general.submitForm("form");
      },
      finalize: function(){}
    },

    'list': {
      init: function(){
        RP6.list.init();
      },
      finalize: function(){}
    },

    'list_detail': {
      init: function(){
        RP6.list.init();
      },
      finalize: function(){}
    },

    'ownerlogin': {
      init: function(){
        RP6.detail.init();
        $(".print-page").click(function (e) {
            e.preventDefault();
            window.open($(this).data("url"), $(this).data("title"), "width=1020, height=700, scrollbars=yes");
        });
      },
      finalize: function() { }
    },

    'detailproject': {
      load: function(){

        RP6.project.init();
        RP6.slideshow.init('.slideshow--detail .carousel-inner');
        RP6.general.submitForm("form");

        $('.table--project-models tr[data-href]').click(function() {
          window.location = $(this).data('href');
        });

      }
    },

    'visit_form': {
      init: function() {
        RP6.general.floatLabels();
        RP6.general.submitForm("form");
      }
    },

  };

  SK.professional_publication_search = {
    init: SK.publication_search.init
  };

  SK.professional_publication_detail = {
    init: SK.publication_detail.init
  };

  SK.project_detail = {
    init: SK.detailproject.load,
    finalize: SK.publication_detail.init
  };
  SK.project_search = {
    init: SK.publication_search.init
  };


  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = SK;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery, RP6, RP6_VARS); // Fully reference jQuery & RP6 JS Module after this point.
